module.exports = __webpack_public_path__ + "static/media/play-stop-button-over.bc707427.svg";